// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"511b0e82","732":"f94a18a6","977":"51d498e2"}[chunkId] + ".chunk.js";
};